import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/eval/Complete')({
  component: RouteComponent,
})

function RouteComponent() {
  const close = () => {
    parent.window.close()
  }

  return (
    // 학생 응시 화면 모바일 최적화 클래스 추가 25.04.15
    <div className="noti-box__outer mobile">
      <div className="noti-box noti-style4">
        <p className="noti-box__txt1">수고하셨습니다!</p>
        <p className="noti-box__txt1">답안을 제출했습니다.</p>
      </div>

      {/* <div className="btn-wrap btn-width2 con-mt4">
                <button type="button" className="btn btn-default line lg2" onClick={close}>
                    <Icon icon="out" />
                    나가기
                </button>
            </div> */}
    </div>
  )
}
